import type { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { useAuthStore } from "@/stores/auth.store";

/**
 * 인증 확인 가드
 * 토큰이 없으면 로그인 페이지로 리다이렉트
 */
export function authGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  const authStore = useAuthStore();

  // 로그인 페이지는 체크하지 않음
  if (to.path === "/login") {
    // 이미 로그인된 경우 메인으로
    if (authStore.isAuthenticated) {
      next("/");
    } else {
      next();
    }
    return;
  }

  // 토큰이 없으면 로그인 페이지로
  if (!authStore.isAuthenticated) {
    next({
      path: "/login",
      query: { redirect: to.fullPath }, // 로그인 후 원래 페이지로 돌아가기 위해
    });
    return;
  }

  // 인증 통과
  next();
}
